// src/api/talleresNoAutorizadosApi.js
import axiosInstance from "./axiosConfig";

export const getTalleresNoAutorizados = () => {
  return axiosInstance.get("/talleres-no-autorizados");
};

export const createTalleresNoAutorizados = (data) => {
  return axiosInstance.post("/talleres-no-autorizados", data);
};
